import { createContext, useContext, useState, useEffect } from "react"
import { baseURL } from "../../../../services/api"

export const SimulacaoProdutoContext = createContext()

export const SimulacaoProdutoProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  async function getDataSimulationProducts(e) {
    setLoading(true)

    const params = {
      codigo_produto: e.codigo_produto,
      codigo_impressao: e.codigo_impressao,
      quantidade_batidas: e.quantidade_batidas,
      quantidade: e.quantidade,
      prazo_entrega: e.prazo_entrega,
      perc_comissao: 10,
      codigo_cor: 0,
    }

    console.log("PARAMS, ", params)
    const { data } = await baseURL.post("/markup/simula-quantidades-produtos", params)

    setData(data)
    setLoading(false)

    console.log(params)
  }

  console.log(data)

  // useEffect(() => {
  //   getDataSimulationProducts({
  //     numero_pedido: "",
  //     data_entrada: "",
  //     data_saida: "",
  //   })
  // }, [])

  return (
    <SimulacaoProdutoContext.Provider value={{ data, loading, getDataSimulationProducts }}>
      {children}
    </SimulacaoProdutoContext.Provider>
  )
}

export const useSimulacaoProduto = () => {
  const context = useContext(SimulacaoProdutoContext)
  return context
}
